import React from 'react';
import { PropTypes as T } from 'prop-types';
import { Label } from 'reactstrap';

export default function ColFormLabel({ children, className, ...props }) {
  const classNameWithLabel = ['col-form-label', className].filter(c => c).join(' ');

  return (
    <Label className={classNameWithLabel} {...props}>
      { children }
    </Label>
  );
}

ColFormLabel.propTypes = {
  className: T.string,
  children: T.oneOfType([
    T.arrayOf(T.node),
    T.node,
  ]),
};

ColFormLabel.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./app/components/bootstrap/col_form_label/index.jsx